import React from 'react';
import './style.scss';
import { MarketNftStatuses } from '../../../components/pages/marketPage/Interfaces';
import { API_NftDetails } from 'shared';
import { IUseFreeNft } from '../../../hooks/freeNft/useFreeNft';
import { SetState } from '../../../interfaces/SetState';
import MarketNftDescription from '../../../components/pages/marketPage/description';
import NftImage from '../../../components/general/nft/image';
import MarketPageActionHint from '../../../components/pages/marketPage/actionHint';
import MarketPageActionButton from '../../../components/pages/marketPage/actionButton';
import MarketPageArrows from '../../../components/pages/marketPage/arrows';
import MarketPagePromoCode from '../../../components/pages/marketPage/promoCode';

interface Props {
  status: MarketNftStatuses;
  nft: API_NftDetails;
  freeNft: IUseFreeNft;
  actionLoading: boolean;
  setActionLoading: SetState<boolean>;
}

const MarketPagePC = ({
  status,
  nft,
  freeNft,
  actionLoading,
  setActionLoading
}: Props) => {
  const { nftLoading, handleRightClick, handleLeftClick, update } = freeNft;

  return (
    <div className='market-page-pc'>
      <MarketNftDescription
        nft={nft}
        status={status}
        className='market-description-wrapper'
        loading={nftLoading}
      />
      <NftImage
        nft={nft}
        className='market-image-wrapper'
        loading={nftLoading}
        disabled={
          status !== MarketNftStatuses.AVAILABLE &&
          status !== MarketNftStatuses.MINTED
        }
      />
      <div className='market-right-wrapper'>
        <MarketPageActionHint
          status={status}
          price={nft.price}
          className='mrw-hint'
        />
        <MarketPageActionButton
          nft={nft}
          status={status}
          inactive={nftLoading}
          update={update}
          loading={actionLoading}
          setLoading={setActionLoading}
          className='mrw-button'
        />
        <MarketPageArrows
          handleLeft={handleLeftClick}
          handleRight={handleRightClick}
          inactive={nftLoading || actionLoading}
          className='mrw-arrows'
        />
        <MarketPagePromoCode status={status} />
      </div>
    </div>
  );
};

export default MarketPagePC;
